export class PanelFacturacion {
  private constructor(
    public readonly id: number,
    public readonly periodo: string,
    public readonly cantidadClinicasActivas: number,
    public readonly cantidadClinicasNuevas: number,
    public readonly cantidadClinicasDadasDeBaja: number,
    public readonly cantidadClinicasQueAbonaron: number,
    public readonly cantidadClinicasConDeuda: number,
    public readonly dineroRecaudado: number,
    public readonly dineroPendientePago: number,
    public readonly fechaInicioPeriodo: Date,
    public readonly fechaFinPeriodo: Date,
    public readonly notas?: string
  ) {}

  static create(
    id: number,
    periodo: string,
    cantidadClinicasActivas: number,
    cantidadClinicasNuevas: number,
    cantidadClinicasDadasDeBaja: number,
    cantidadClinicasQueAbonaron: number,
    cantidadClinicasConDeuda: number,
    dineroRecaudado: number,
    dineroPendientePago: number,
    fechaInicioPeriodo: Date,
    fechaFinPeriodo: Date,
    notas?: string
  ): PanelFacturacion {
    return new PanelFacturacion(
      id,
      periodo,
      cantidadClinicasActivas,
      cantidadClinicasNuevas,
      cantidadClinicasDadasDeBaja,
      cantidadClinicasQueAbonaron,
      cantidadClinicasConDeuda,
      dineroRecaudado,
      dineroPendientePago,
      fechaInicioPeriodo,
      fechaFinPeriodo,
      notas
    );
  }

  getEfectividad(): number {
    const total = this.dineroRecaudado + this.dineroPendientePago;
    if (total === 0) return 0;
    return (this.dineroRecaudado / total) * 100;
  }
}
